<template>
  <div class="clearfix">
    <!-- 上传图片，需求预览 -->
    <a-upload
      list-type="picture-card"
      :file-list="fileList"
      :beforeUpload="beforeUpload"
      @preview="handlePreview"
      @change="handleChange"
      v-bind="$attrs"
      :multiple="multiple"
      style="width:100%;"
      v-if="uploadType === 'image'"
      class="upload-image-area"
    >
      <!-- 上传图片 -->
      <span class="upload-image-icon">
        <Icon type="upload-img" />
      </span>

      <div class="upload-image-tips">
        <div class="ant-upload-text">
          {{ $t('com_upload_image') }}
        </div>
        {{ $t('com_upload_support_type') + ': ' + acceptImageType.join(', ') }},
        {{ $t('com_upload_tip3') }}{{ formatSize(acceptImageSize) }}
      </div>
    </a-upload>

    <!-- 上传图片预览 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
      v-if="uploadType === 'image'"
      destroyOnClose
    >
      <img style="width: 100%" :src="previewImage" />
    </a-modal>

    <!-- 上传文件，允许拖拉拽 -->
    <a-upload-dragger
      :multiple="multiple"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :list-type="null"
      @preview="handlePreview"
      @change="handleChange"
      class="upload-file-area"
      v-if="uploadType === 'file'"
    >
      <div class="upload-description">
        <p class="ant-upload-drag-icon" style="margin:0 10px 0 0;">
          <Icon type="upload-file" />
        </p>
        <div>
          <p class="ant-upload-text">
            {{ $t('com_upload_tip1') }}
          </p>
          <p class="ant-upload-hint">
            {{
              acceptFileTypes !== 'any'
                ? $t('com_upload_support_type') + ': ' + acceptFileTypes?.join(', ') + '.'
                : ''
            }}
            {{ $t('com_upload_tip3') }}
            {{ formatSize(acceptFileSize) }}
          </p>
        </div>
      </div>
    </a-upload-dragger>

    <!-- 上传视频 -->
    <a-upload-dragger
      :multiple="multiple"
      :file-list="fileList"
      :before-upload="beforeUpload"
      list-type="picture"
      @preview="handlePreviewVideo"
      :preview-file="previewFile"
      @change="handleChange"
      class="upload-file-area"
      v-if="uploadType === 'video'"
    >
      <div class="upload-description">
        <p class="ant-upload-drag-icon" style="margin:0 10px 0 0;">
          <Icon type="upload-file" />
        </p>
        <div>
          <p class="ant-upload-text">
            {{ $t('com_upload_tip_video') }}
          </p>
          <p class="ant-upload-hint">
            {{ $t('com_upload_support_type') + ': ' + acceptVideoType.join(', ') }}.
            {{ $t('com_upload_tip3') }}
            {{ formatSize(acceptVideoSize) }}
          </p>
        </div>
      </div>
      <canvas id="videoPreviewCanvas" style="display:none;"></canvas>
    </a-upload-dragger>

    <div class="upload-error" v-if="errorText">
      {{ errorText }}
    </div>
  </div>
</template>
<script>
import { getBase64 } from '@/libs/utils';
import { generateSignedUrl, uploadMultipleFiles, getFileNameFromUrl } from '@/config/oss';

export default {
  props: {
    // 最多允许文件个数,
    maxCount: {
      type: Number,
      default: 1,
    },

    // 文件列表
    value: {
      type: Array,
      default: () => [],
    },

    // 是否允许多选（并非上传个数， 上传个数由maxCount）
    // 为true时，可以选择多个文件一起上传到Aliyun OSS
    multiple: {
      type: Boolean,
      default: false,
    },

    // aliyun bucket
    uploadBucket: {
      type: String,
      // 默认是这个bucket
      default: null,
    },

    // filename
    uploadFileName: {
      type: String,
      default: null,
    },

    // 下载文件名,当为true时，表示与上传的文件名同名
    downloadFileName: {
      type: [String, Boolean],
      default: null,
    },

    // 默认手动上传(如果是附件，可能文件太太，如果即时上传，会浪费流量)，即点保存或提交时才上传
    // 此时需要调该组件的 handleUpload 方法
    // for example: this.$refs.upload.handleUpload(()=>{
    //  console.log('上传成功');
    //  执行表单提交
    // })
    manuallyUpload: {
      type: Boolean,
      default: true,
    },

    // 上传到Aliyun OSS的指定目录，默认images
    uploadDirInOSS: {
      type: String,
      default: 'images',
    },

    // 上传类型：支持'file'、'image'、'video'
    uploadType: {
      type: String,
      default: 'image',
    },

    // 上传的图片类型
    acceptImageType: {
      type: Array,
      default: () => [
        'jpeg', // JPEG
        'png', // PNG
        // 'gif', // GIF
        // 'bmp', // BMP
        // 'webp', // WEBP
        // 'tiff', // TIFF
        // 'svg+xml', // SVG
      ],
    },
    // 上传的图片大小
    acceptImageSize: {
      type: Number,
      // 默认20M
      default: 20 * 1024 * 1024,
    },

    // 上传的文件类型，='any'表示任意类型
    acceptFileTypes: {
      type: [Array, String],
      default: () => [
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.ppt',
        '.pptx',
        '.pdf',
        '.txt',
        '.zip',
        '.rar',
        '.7z',
      ],
    },
    // 上传的文件大小
    acceptFileSize: {
      type: Number,
      // 默认100M
      default: 100 * 1024 * 1024,
    },

    // 上传视频类型
    acceptVideoType: {
      type: Array,
      default: () => ['mp4', '3gp'],
    },

    // 上传的视频文件大小
    acceptVideoSize: {
      type: Number,
      // 默认200M
      default: 200 * 1024 * 1024,
    },

    // 上传成功后的回调
    onSuccess: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      filters: this.$options.filters,
      previewVisible: false,
      previewImage: '',
      fileList: [
        // {
        //   uid: '-1',
        //   name: 'image.png',
        //   status: 'done',
        //   url:
        //     'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // },
      ],

      // 报错信息
      errorText: '',
    };
  },
  watch: {
    value: {
      async handler(val) {
        this.fileList = await this.convertToFileList(val);
      },
      immediate: true,
    },
  },
  async created() {
    this.fileList = await this.convertToFileList(this.value);
  },

  methods: {
    // convert file to filelist format
    async convertToFileList(files) {
      try {
        let _files = await Promise.all(
          files.map(async (file, index) => {
            if (file) {
              const fullUrl =
                typeof file === 'string' ? await generateSignedUrl({ objectKey: file }) : '';
              const _obj = {
                uid: index.toString(), // 以字符串形式处理 UID
                name: file.name || (typeof file === 'string' ? file : ''),
                status: 'done',
                url: fullUrl || file.url,
                result: file.result || {
                  url: fullUrl || file.url,
                },
                originFileObj: file.originFileObj, // 这里假设 file 是 File 对象
              };
              return _obj;
            }
            return;
          })
        );
        _files = (_files || []).filter(item => !!item);
        return _files || [];
      } catch (err) {
        console.error('处理文件列表时出错:', err);
        return [];
      }
    },

    beforeUpload(_file, _fileList) {
      return false;
    },

    // 取消预览
    handleCancel() {
      this.previewVisible = false;
    },

    // 预览图片
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    // 预览视频
    async handlePreviewVideo(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    // 上传文件列表改变
    async handleChange({ file, fileList }) {
      // 变化的时候，清除上一次的错误
      this.errorText = '';

      // 删除的时候不验证
      if (file.status === 'removed') {
        this.fileList = fileList;
        this.onChange(this.fileList, 'removed');
        return;
      }

      // 当有uploadFileName时，上传的文件名必须为uploadFileName的值
      if (this.uploadFileName && file.name !== this.uploadFileName) {
        const errorMessage = `${this.$t('com_upload_filename_error', {
          filename: this.uploadFileName,
          currentFilename: file.name,
        })}`;
        this.$message.error(errorMessage);
        this.errorText = errorMessage;
        return false;
      }

      // 限制文件大小
      if (this.uploadType === 'image') {
        if (file.size > this.acceptImageSize) {
          const errorMessage = `${this.$t('com_upload_size_error', {
            maxSize: this.filters.formatSize(this.acceptImageSize),
          })}`;
          this.$message.error(errorMessage);
          this.errorText = errorMessage;
          return false;
        }
      } else if (this.uploadType === 'file') {
        if (file.size > this.acceptFileSize) {
          const errorMessage = `${this.$t('com_upload_size_error', {
            maxSize: this.filters.formatSize(this.acceptFileSize),
          })}`;
          this.$message.error(errorMessage);
          this.errorText = errorMessage;
          return false;
        }
      }

      // 如果是图片类型，只允许上传图片
      if (this.uploadType === 'image') {
        const imgType = file?.type?.split('/')[1];
        if (!this.acceptImageType.includes(imgType)) {
          const errorMessage = `${this.$t('com_upload_tip')} ${this.acceptImageType.join(', ')}`;
          this.$message.error(errorMessage);
          this.errorText = errorMessage;
          return false;
        }
      } else if (this.uploadType === 'file') {
        // 不等于any时，限制文件类型
        if (this.acceptFileTypes !== 'any') {
          // 如果是文件类型，只允许上传文件
          const suffix = file.name.substring(file.name.lastIndexOf('.'));
          if (this.acceptFileTypes.indexOf(suffix) === -1) {
            const errorMessage = `${this.$t('com_upload_tip')} ${this.acceptFileTypes.join(', ')}`;
            this.$message.error(errorMessage);
            this.errorText = errorMessage;
            return false;
          }
        }
      }

      // 限制文件个数
      fileList = fileList.slice(-this.maxCount);

      this.fileList = fileList;

      // 添加文件夹前缀,修改originFileObj
      this.fileList.forEach(file => {
        if (file.originFileObj) {
          // 设置下载文件名
          if (this.downloadFileName) {
            // downloadFileName为true时，下载文件名跟上传的原文件名保持一致
            if (this.downloadFileName === true) {
              file.downloadFileName = file.name || file.originFileObj.name;
            } else {
              file.downloadFileName = this.downloadFileName;
            }
          }

          file.name = `${this.uploadDirInOSS}/${file.name || file.originFileObj.name}`;
        }
      });

      // 选择文件后自动上传
      if (this.manuallyUpload) {
        // 父级通过ref调用handleUpload就去上传
        // 如：this.$refs.upload.handleUpload();
        // 上传成功后，将列表传给上层组件
        this.$emit('selected', this.fileList);
      } else {
        // 选择文件后，自动上传至OSS
        this.handleUpload();
      }
    },

    // 上传文件
    async handleUpload(callback) {
      // 上传到服务器
      await uploadMultipleFiles({
        files: this.fileList,
        uploadBucket: this.uploadBucket,
        callback: (status, result) => {
          this.onChange(this.fileList);
          console.log('上传成功后，将列表传给上层组件', result);
          // reset
          this.fileList = [];

          callback && callback(status, result);
        },
      });
    },

    formatSize(size) {
      if (size < 1024) {
        return `${size} Bytes(1KB=1024Bytes)`; // 小于 1KB 显示为 Bytes
      } else if (size < 1024 * 1024) {
        return `${Math.floor(size / 1024)} KB(1M=1024KB)`; // 小于 1MB 显示为 KB
      } else if (Math.floor(size < 1024 * 1024 * 1024)) {
        return `${Math.floor(size / (1024 * 1024))} MB(1G=1024MB)`; // 小于 1GB 显示为 MB
      } else {
        return `${Math.floor(size / (1024 * 1024 * 1024))} GB`; // 大于等于 1GB 显示为 GB
      }
    },

    onChange(fileList, type) {
      if (type === 'removed') {
        // 删除的时候，不需要上传
        this.$emit('change', fileList);
        return;
      } else if (type === 'pasted') {
        // 粘贴的时候，不需要上传
        this.$emit('change', fileList);
        return;
      }

      // 仅仅保存一个文件名，便于后续文件迁移到别的域名（而不用批量修改数据）
      const originalFileList = fileList.map(item => {
        return getFileNameFromUrl(item?.result?.url);
      });

      console.log('fileList', fileList);
      console.log('originalFileList', originalFileList);

      // 上传成功后，将列表传给上层组件
      this.$emit('change', originalFileList, fileList);
    },

    // 预览
    previewFile() {
      return new Promise(resolve => {
        resolve(
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAT5JREFUaEPtmVEOwyAIhunNtpNtO9l2s60kdTHOGkAUXPClLxb5+FGo3WDxsS3uPwSAtYKhgGcFLgBwAwB8Wo4XADx2P/D5M1op9HTgfHIYnb9yAd6WYacGu6XA3wHMPrHKAFbX5ygQAMw9FQqQIsCMKmc6aX3NPXA/vMMzu1p0ON7vRXQ6QL4gVs4ExPT7O90UAL3ohTAHSKGUgrgBkKrhCgAhml1lZaO4A+CmlFsAakq5BkhqdNehbgNZ7kra7+71uw0IAU6/sBr2hrfTVAWodcHdHlj6GKVGPS8HbhTA2wRJd2oOQNmorU7VFECSMiXMdAC8CEtVVpIy5gDSD5ez96YrEABFBEIBUgS082ZkLzTQV5Lp7maOtMrASWyA5X9wLP+LaWA26Jmefeev5/lhKQDUQ8o0GAowA6Y+/QMvjGoxJPNiRwAAAABJRU5ErkJggg=='
        );
      });
    },

    // 重置
    reset() {
      this.fileList = [];
    },
  },
};
</script>
<style lang="less" scoped>
// 上传错误
.upload-error {
  color: red;
  font-size: 14px;
  height: 24px;
  line-height: 24px;
}

// 上传图片样式
::v-deep .upload-image-area {
  display: flex;
  .ant-upload-select-picture-card {
    width: auto;
    padding-left: 10px;
    padding-right: 10px;
    margin: 0;
    flex: 1;

    .ant-upload {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .upload-image-icon {
      color: #666;
      margin-top: 8px;
      svg {
        width: 48px;
        height: 48px;
      }
    }
    .ant-upload-text {
      font-size: 16px;
      color: #666;
    }

    // icon
    .anticon-plus {
      font-size: 32px;
      color: @primary-color;
    }

    .upload-image-tips {
      color: #999;
      font-size: 14px;
      text-align: left;
      padding-left: 15px;
    }
  }
}

// 上传文件样式
::v-deep .upload-file-area {
  .ant-upload {
    margin-bottom: 10px;

    .ant-upload-drag-icon {
      font-size: 32px;
      color: #999;
      svg {
        width: 32px;
        height: 32px;
      }
    }
    &.ant-upload-drag {
      .ant-upload-btn {
        padding: 5px 0;

        p.ant-upload-text {
          font-size: 16px;
          color: #666;
        }

        p.ant-upload-hint {
          color: #999;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
